import React, { useContext, useState } from "react";
import AppContext from "../../../context/store";
import { Grid, Column } from "../../../theme/Grid";
import AuthContainer from "../../../components/AuthContainer";
import Button from "../../../theme/Button";
import Axios from "axios";
import { toast } from "react-toastify";
import Linkgo from "../../../assets/images/icons/Linkgo";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Card, CircularProgress } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "60vh",
  },
  card: {
    maxWidth: 400,
    textAlign: "center",
    border: "none !important",
    padding: theme.spacing(4),
  },
  icon: {
    fontSize: 80,
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  description: {
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
  },
  button: {
    marginTop: theme.spacing(2),
  },
}));

const LinkGoLogin = () => {
  const context = useContext(AppContext);
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const handleLinkGoLogin = async () => {
    setLoading(true);

    try {
      const response = await Axios.post(`${context.api_endpoint}/company/auth-link/linkgo`, {});

      if (response.status === 201) {
        const { email, token } = response.data;
      const tokenStringfy = JSON.stringify(token);
        const linkgoUrl = `https://app.linkgo.tr/auth/external/` + tokenStringfy.replaceAll('"', '');
        
        window.open(linkgoUrl, '_blank', 'noopener,noreferrer');
      }
    } catch (error) {
      console.error('LinkGo login error:', error);

      if (error.response?.status === 3009) {
        toast.error('LinkGo entegrasyonu için özel durum. Lütfen tekrar deneyin.');
      } else if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error('LinkGo giriş işlemi sırasında bir hata oluştu. Lütfen tekrar deneyin.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthContainer>
      <Grid>
        <Column className="xs-12 sm-12 md-12 lg-12">
          <div className={classes.container}>
            <div className={classes.card}>
              <Linkgo className={classes.icon} />
              <Typography variant="h5" className={classes.title}>
                LinkGo'ya Giriş
              </Typography>
              <Typography variant="body1" className={classes.description}>
                LinkGo uygulamasına güvenli bir şekilde giriş yapmak için aşağıdaki butona tıklayın.
              </Typography>
              <Button
                title={loading ? "Giriş yapılıyor..." : "LinkGo'ya Giriş Yap"}
                size="lg"
                fullWidth
                textColor="white"
                backgroundColor="primary"
                onClick={handleLinkGoLogin}
                disabled={loading}
                className={classes.button}
                startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
              />
            </div>
          </div>
        </Column>
      </Grid>
    </AuthContainer>
  );
};

export default LinkGoLogin; 